'use client';

import { PropsWithChildren } from 'react';
import PiwikProProvider from '@piwikpro/next-piwik-pro';

type Props = PropsWithChildren;

export function AnalyticsContainer({ children }: Props) {
  if (
    !process.env.NEXT_PUBLIC_CONTAINER_ID ||
    !process.env.NEXT_PUBLIC_CONTAINER_URL
  ) {
    // eslint-disable-next-line
    return <>{children}</>;
  }

  return (
    <PiwikProProvider
      containerId={process.env.NEXT_PUBLIC_CONTAINER_ID}
      containerUrl={process.env.NEXT_PUBLIC_CONTAINER_URL}
    >
      {children}
    </PiwikProProvider>
  );
}
